import {myProposals, proposal, proposals, uploadFile} from "../../../api/entryPoint";
import Swal from "sweetalert2";
import {formatDate} from "@fullcalendar/vue";
import api from "../../services/axiosHeader.js";

export const state = {
    list: [],
    listPropsUser: [],
    listPropsFolder: [],
    details: {},
    isLoading: true,
    isLoadingConnect: true,
    isLoadingFolders: true,
    isLoadingTitle: true,
}

export const mutations = {
    SET_LIST(state, newValue) {
        state.list = newValue
    },
    SET_LIST_PROPS_USER(state, newValue) {
        state.listPropsUser = newValue
    },
    SET_LIST_PROPS_FOLDER(state, newValue) {
        state.listPropsFolder = newValue
    },
    SET_DETAILS(state, newValue) {
        state.details = newValue
    },
    SET_IS_LOADING(state, payload) {
        state.isLoading = payload
    },
    SET_IS_LOADING_TITLE(state, payload) {
        state.isLoadingTitle = payload
    },
    SET_IS_LOADING_FOLDERS(state, payload) {
        state.isLoadingFolders = payload
    },
    SET_IS_LOADING_CONNECT(state, payload) {
        state.isLoadingConnect = payload
    },
}

export const getters = {
    getList(state) {
        return state.list;
    },
    getListPropsFolder(state) {
        return state.listPropsFolder;
    },
    getListPropsUser(state) {
        return state.listPropsUser;
    },
    getDetails(state) {
        return state.details;
    },
    getIsLoading(state) {
        return state.isLoading;
    },
    getIsLoadingTitle(state) {
        return state.isLoadingTitle;
    },
    getIsLoadingFolders(state) {
        return state.isLoadingFolders;
    },
    getIsLoadingConnect(state) {
        return state.isLoadingConnect;
    },
}

export const actions = {
    // List all proposals
    proposalsList({commit, rootState}, payload) {
        commit('SET_IS_LOADING', true);
        let data
        api.get(myProposals + '?page=' + payload).then((res) => {
            commit('SET_LIST', res.data);
            commit('SET_IS_LOADING', false);
            data = res.data;
            commit('SET_IS_LOADING_TITLE', true);
            let dataInjected = [];
            api.get(proposal + '?page=1').then((resultat) => {
                dataInjected = data.items.map((el) => {
                    let temp = resultat.data.find(element => element.id === el.request);
                    if (temp) {
                        el.req = temp;
                    }
                    return el;
                });
                data.items = dataInjected;
                commit('SET_LIST', data);
                commit('SET_IS_LOADING_TITLE', false);
            })
        }).catch((error) => {
            console.log(error);
        });
    },

    // details of proposals by id
    proposalDetails({commit, rootState}, payload) {
        commit('SET_IS_LOADING', true);
        api.get(proposals + '/' + payload)
            .then((res) => {
                commit('SET_DETAILS', res.data[0]);
                commit('SET_IS_LOADING', false);
            }).catch((error) => {
            console.log(error);
        });
    },
    // details of proposals by user connect
    proposalUserConnect({commit}, payload) {
        commit('SET_IS_LOADING_CONNECT', true);
        let user;
        api.get(proposals + '/folders/user/' + payload)
            .then((res) => {
                commit('SET_LIST_PROPS_USER', res.data);
                commit('SET_IS_LOADING_CONNECT', false);
                user = res.data;
                commit('SET_IS_LOADING_TITLE', true);
                let dataInjected = [];
                api.get(proposal + '?page=1').then((resultat) => {
                    dataInjected = user.items.map((el) => {
                        let temp = resultat.data.find(element => element.id === el.request);
                        if (temp) {
                            el.req = temp;
                        }
                        return el;
                    });
                    user.items = dataInjected;
                    commit('SET_LIST_PROPS_USER', user);
                    commit('SET_IS_LOADING_TITLE', false);
                })
            }).catch((error) => {
            console.log(error);
        });
    },
    // details of proposals by folders
    proposalFolder({commit}, payload) {
        commit('SET_IS_LOADING_FOLDERS', true);
        api.get(proposals + '/folders/' + payload)
            .then((res) => {
                commit('SET_LIST_PROPS_FOLDER', res.data);
                commit('SET_IS_LOADING_FOLDERS', false);
            }).catch((error) => {
            console.log(error);
        });
    },
    // Create proposal for a folder
    createProposal({commit, state, rootState}, payload) {
        let data = {
            'poNumber': payload.name,
            'validUntil': payload.date,
            's_quote_detail': payload.description,
            'request': payload.request,
            'drafts': payload.draft,
            's_quote_att_1': payload.file1.data,
            's_quote_att_2': payload.file2.data,
            's_quote_att_3': payload.file3.data,
        }
        api.post(proposals, data).then(res => {
                if (payload.statut === "ajouter") {
                    showAlert({
                        icon: "success",
                        title: "Ajoutée !",
                        text: "Cette proposition a été ajouté avec succès",
                        confirmType: {
                            type: "Ajouter",
                        },
                    });
                } else if (payload.statut === "brouillon") {
                    showAlert({
                        icon: "success",
                        title: "Brouillon !",
                        text: "Cette proposition a été ajouté comme brouillon",
                        confirmType: {
                            type: "Ajouter",
                        },
                    });
                } else {
                    showAlert({
                        icon: "error",
                        title: "Non Ajoutée !",
                        text: "Échec de l'ajout",
                    });
                }
            }
        ).catch(err => {
                showAlert({
                    icon: "error",
                    title: "Non Ajoutée !",
                    text: "Échec de l'ajout",
                });
            }
        )
    },
    // update proposal for a folder
    updateProposal({commit, state, rootState}, payload) {
        let data = {
            'poNumber': payload.name,
            'validUntil': payload.date,
            's_quote_detail': payload.description,
            'request': payload.request,
            'drafts': payload.draft,
            's_quote_att_1': payload.file1.data,
            's_quote_att_2': payload.file2.data,
            's_quote_att_3': payload.file3.data,
        }
        api.post(proposals + '/' + payload.id, data).then(
            (res) => {
                if (payload.message === 'ajouter') {
                    showAlert({
                        icon: "success",
                        title: "Ajoutée !",
                        text: "Cette proposition a été ajouté avec succès",
                        confirmType: {
                            type: "Ajouter",
                        },
                    });
                } else {
                    showAlert({
                        icon: "success",
                        title: "Modifiée",
                        text: "Cette proposition a été modifiée avec succès",
                        confirmType: {
                            type: "Ajouter",
                        },
                    });
                }
            },
            (err) => {
                if (payload.message === 'ajouter') {
                    showAlert({
                        icon: "error",
                        title: "Non Ajoutée !",
                        text: "Echec d'ajout de la proposition",
                    });
                } else {
                    showAlert({
                        icon: "error",
                        title: "Non Modifiée !",
                        text: "Echec de modification de la proposition",
                    });
                }
            }
        ).catch((error) => {
            showAlert({
                icon: "error",
                title: "Non Ajoutée !",
                text: "Echec d'ajout de la proposition",
            });
        });
    },
    /* Delete proposal */
    deleteProposal({commit}, id) {
        return api.delete(proposals + '/' + id);
    },
    /* upload file or image */
    uploadFile({commit}, payload) {
        let data = new formatDate;
        return api.post(uploadFile, data);
    },
}

export function showAlert(data) {
    Swal.fire({
        icon: data.icon,
        title: data.title,
        text: data.text,
        confirmButtonColor: "#b1215c",
        showCancelButton: data.showCancelButton,
        confirmButtonText: data.confirmButtonText
            ? data.confirmButtonText
            : "OK",
        cancelButtonText: data.cancelButtonText,
    }).then((res) => {
        if (data.confirmType) {
            if (data.confirmType.type === "Ajouter") {
                if (res.isConfirmed)
                    return window.location.href = "/proposals";
            }
        }
    });
}